const PLACEHOLDER_PATTERN = /\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g;

export const applyTemplate = (
    template: string,
    vars: Record<string, string>
): string => {
    return template.replace(PLACEHOLDER_PATTERN, (_full, name: string) => {
        const value = vars[name] ?? '';
        return value;
    });
};

export const extractPlaceholders = (template: string): string[] => {
    const result: string[] = [];
    let m: RegExpExecArray | null;
    while ((m = PLACEHOLDER_PATTERN.exec(template)) !== null) {
        result.push(m[1]);
    }
    return Array.from(new Set(result));
};

export const countCaptureGroups = (regexSource: string): number => {
    // Counts "(" that start a capturing group:
    // - "(" not escaped
    // - not "(?" (non-capturing or lookaround)
    // This is not a full parser but works well enough for validation.
    let count = 0;
    let escaped = false;

    for (let i = 0; i < regexSource.length; i++) {
        const c = regexSource[i];

        if (escaped) {
            escaped = false;
            continue;
        }

        if (c === '\\') {
            escaped = true;
            continue;
        }

        if (c === '(') {
            const next = regexSource[i + 1];
            if (next === '?') continue;
            count++;
        }
    }

    return count;
};

export const findDuplicates = (values: string[]): string[] => {
    const seen = new Set<string>();
    const dupes = new Set<string>();
    for (const v of values) {
        if (seen.has(v)) dupes.add(v);
        seen.add(v);
    }
    return Array.from(dupes);
};

export const isObject = (value: unknown): value is Record<string, unknown> => {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
};
